// extracted by mini-css-extract-plugin
module.exports = {"input":"Select__input___QLvvz"};